"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = require("@0x/assert");
var utils_1 = require("@0x/utils");
var order_set_1 = require("../order_set");
var order_store_1 = require("../order_store");
var base_sra_order_provider_1 = require("./base_sra_order_provider");
var SRAPollingOrderProvider = /** @class */ (function (_super) {
    __extends(SRAPollingOrderProvider, _super);
    /**
     * Instantiates a HTTP [Standard Relayer API](https://github.com/0xProject/standard-relayer-api)
     * Polling Order Provider
     * @param opts `SRAPollingOrderProviderOpts` containing the httpEndpoint to an SRA backend and polling options
     * @param orderStore The `OrderStore` where orders are added and removed from
     */
    function SRAPollingOrderProvider(opts, orderStore) {
        var _this = _super.call(this, orderStore, opts.httpEndpoint, opts.perPage) || this;
        _this._assetPairKeyToPollingIntervalId = new Map();
        assert_1.assert.isNumber('pollingIntervalMs', opts.pollingIntervalMs);
        _this._pollingIntervalMs = opts.pollingIntervalMs;
        return _this;
    }
    /**
     * Creates a http polling subscription and fetches the current orders from SRA.
     * @param makerAssetData the maker asset Data
     * @param takerAssetData the taker asset Data
     */
    SRAPollingOrderProvider.prototype.createSubscriptionForAssetPairAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var assetPairKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                        // Do nothing if we already have a polling interval or websocket created for this asset pair
                        if (this._assetPairKeyToPollingIntervalId.has(assetPairKey)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this._fetchAndCreatePollingAsync(makerAssetData, takerAssetData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Destroys the order provider, removing any subscriptions
     */
    SRAPollingOrderProvider.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, _c, _d, assetPairKey, id;
            return __generator(this, function (_e) {
                try {
                    for (_b = __values(this._assetPairKeyToPollingIntervalId), _c = _b.next(); !_c.done; _c = _b.next()) {
                        _d = __read(_c.value, 2), assetPairKey = _d[0], id = _d[1];
                        clearInterval(id);
                        this._assetPairKeyToPollingIntervalId.delete(assetPairKey);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Fetches all of the orders for both sides of the orderbook and stores them. A polling subscription
     * is created performing this action every pollingIntervalMs
     */
    SRAPollingOrderProvider.prototype._fetchAndCreatePollingAsync = function (makerAssetData, takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            var assetPairKey, orders, pollingIntervalId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                        return [4 /*yield*/, this._fetchLatestOrdersAsync(makerAssetData, takerAssetData)];
                    case 1:
                        orders = _a.sent();
                        // Set the OrderSet for the polling to diff against
                        return [4 /*yield*/, this._updateStoreAsync({ added: orders, removed: [], assetPairKey: assetPairKey })];
                    case 2:
                        // Set the OrderSet for the polling to diff against
                        _a.sent();
                        pollingIntervalId = this._createPollingSubscription(makerAssetData, takerAssetData);
                        this._assetPairKeyToPollingIntervalId.set(assetPairKey, pollingIntervalId);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates the polling interval fetching the orders, calculating the diff and updating the store
     */
    SRAPollingOrderProvider.prototype._createPollingSubscription = function (makerAssetData, takerAssetData) {
        var _this = this;
        var assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
        var pollingIntervalId = utils_1.intervalUtils.setAsyncExcludingInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var previousOrderSet, orders, orderSet, diff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        previousOrderSet = this._orderStore.getOrderSetForAssetPair(assetPairKey);
                        return [4 /*yield*/, this._fetchLatestOrdersAsync(makerAssetData, takerAssetData)];
                    case 1:
                        orders = _a.sent();
                        orderSet = new order_set_1.OrderSet();
                        return [4 /*yield*/, orderSet.addManyAsync(orders)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, previousOrderSet.diffAsync(orderSet)];
                    case 3:
                        diff = _a.sent();
                        return [4 /*yield*/, this._updateStoreAsync(__assign({}, diff, { assetPairKey: assetPairKey }))];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, this._pollingIntervalMs, function (_) {
            // TODO(dave4506) Add richer errors
            throw new Error("Fetching latest orders for asset pair " + makerAssetData + "/" + takerAssetData);
        });
        return pollingIntervalId;
    };
    return SRAPollingOrderProvider;
}(base_sra_order_provider_1.BaseSRAOrderProvider));
exports.SRAPollingOrderProvider = SRAPollingOrderProvider;
//# sourceMappingURL=sra_polling_order_provider.js.map